<ng-template #content><ng-content></ng-content></ng-template>
@if (type === HEADING_TYPES.h1) {
	<h1
		id="{{ name }}"
		[ngClass]="{
			gray: color === 'gray',
			xs: size === HEADING_SIZES.xs,
			sm: size === HEADING_SIZES.sm,
			md: size === HEADING_SIZES.md,
			lg: size === HEADING_SIZES.lg,
			xl: size === HEADING_SIZES.xl,
			'no-margin': noMargin,
			capitalize: capitalize
		}">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</h1>
}
@if (type === HEADING_TYPES.h2) {
	<h2
		id="{{ name }}"
		[ngClass]="{
			gray: color === 'gray',
			xs: size === HEADING_SIZES.xs,
			sm: size === HEADING_SIZES.sm,
			md: size === HEADING_SIZES.md,
			lg: size === HEADING_SIZES.lg,
			xl: size === HEADING_SIZES.xl,
			bgWhite: isBgWhite,
			'no-margin': noMargin
		}">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</h2>
}
@if (type === HEADING_TYPES.h3) {
	<h3
		id="{{ name }}"
		[ngClass]="{
			gray: color === 'gray',
			xs: size === HEADING_SIZES.xs,
			sm: size === HEADING_SIZES.sm,
			md: size === HEADING_SIZES.md,
			lg: size === HEADING_SIZES.lg,
			xl: size === HEADING_SIZES.xl,
			'no-margin': noMargin
		}">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</h3>
}
@if (type === HEADING_TYPES.h4) {
	<h4
		id="{{ name }}"
		[ngClass]="{
			gray: color === 'gray',
			xs: size === HEADING_SIZES.xs,
			sm: size === HEADING_SIZES.sm,
			md: size === HEADING_SIZES.md,
			lg: size === HEADING_SIZES.lg,
			xl: size === HEADING_SIZES.xl,
			'no-margin': noMargin
		}">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</h4>
}
